import DOMPurify from "dompurify";
import { marked } from "marked";

const HTML_CONTENT_PATTERN = /<\s*(p|h[1-6]|ul|ol|li|div|blockquote|table|strong|em|br)\b/i;

export function looksLikeHtml(content: string): boolean {
  const trimmed = content.trim();
  if (!trimmed) return false;
  return HTML_CONTENT_PATTERN.test(trimmed);
}

/** Convert stored content to HTML for the WYSIWYG editor. */
export function toEditorHtml(content: string): string {
  if (!content.trim()) return "";
  if (looksLikeHtml(content)) return content;
  const parsed = marked.parse(content, { async: false });
  return typeof parsed === "string" ? parsed : "";
}

export function sanitizeLegalHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ["target", "rel"],
  });
}
